import { render, staticRenderFns } from "./AddPractitioner.vue?vue&type=template&id=83eee6f6&scoped=true"
import script from "./AddPractitioner.vue?vue&type=script&lang=js"
export * from "./AddPractitioner.vue?vue&type=script&lang=js"
import style0 from "./AddPractitioner.vue?vue&type=style&index=0&id=83eee6f6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83eee6f6",
  null
  
)

export default component.exports